import React, { useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IntroUpdate, ProfileGet } from "../../apis/api/ProfileApi";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Select from "react-select";
import { CountryList } from "../../apis/api/CountryList";
import { useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";

const EditintroModal = ({ show, handleClose, data }) => {
  const company_id = Cookies.get("company_id");
  const userId = Cookies.get("userID");
  const dispatch = useDispatch();
  const { country } = useSelector((state) => state.countrySlice);

  console.log(country, "country");

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    dispatch(CountryList());
    if (data) {
      let  selectedCountry;
      if (data && country.length > 0) {
        selectedCountry = country.find(
          (item) => (item.value.includes(':') ? item.value.substring(item.value.indexOf(':') + 1) : item.value) === data?.country
        );}
      
      reset({
        foundationDate: data?.foundation_date
          ? new Date(Number(data.foundation_date) * 1000)
          : null,
        companyName: data?.company_name || "",
        email: data?.email || "",
        contact: data?.contact || "",
        clientCountry: selectedCountry || null,
        city: data?.city || "",
        payPassword: data?.pay_password || "",
        employeeCount: data?.employee_count || "",
        companyAddress: data?.company_address || "",
        companyBio: data?.bio || "",
        email: data?.company_email,
      });
    }
  }, [data,reset]);

  const onSubmit = async (formDataRaw) => {
    const formData = new FormData();
  
    for (const key in formDataRaw) {
      if (formDataRaw[key] !== undefined && formDataRaw[key] !== null) {
        let value = formDataRaw[key];
  
        // Handle react-select object
        if (typeof value === "object" && value?.value !== undefined) {
          value = value.value;
        }
  
        // Handle date conversion
        if (value instanceof Date) {
          value = value.toISOString();
        }
  
        formData.append(key, value);
      }
    }
  
    formData.append("company_id", company_id);
  
    const response = await dispatch(IntroUpdate(formData));
    
  
    if (response.payload?.status === "success") {
      toast.success("Intro updated successfully");
      dispatch(ProfileGet({ userId, company_id }));
    } else {
      toast.error("Error while updating intro");
    }
  
    handleClose();
    reset();
  };
  

  return (
    <Modal show={show} size="lg" centered onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Membership Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          onSubmit={handleSubmit(onSubmit)}
          className="p-4 border rounded shadow bg-white"
        >
          <div className="row">
            <div className="col-md-6 mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Company Name *</Form.Label>
                <Form.Control
                  {...register("companyName", { required: "Required" })}
                  placeholder="Enter company name"
                  isInvalid={!!errors.companyName}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.companyName?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </div>

            <div className="col-md-6 mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Email *</Form.Label>
                <Form.Control
                  type="email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^\S+@\S+$/i,
                      message: "Invalid email",
                    },
                  })}
                  placeholder="Enter email"
                  isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </div>

            <div className="col-md-6 mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Contact *</Form.Label>
                <Form.Control
                  {...register("contact", { required: "Contact is required" })}
                  placeholder="Enter contact number"
                  isInvalid={!!errors.contact}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.contact?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </div>

            <div className="col-md-6 mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Establish Date *</Form.Label>
                <Controller
                  control={control}
                  name="foundationDate"
                  rules={{ required: "Required" }}
                  render={({ field }) => (
                    <DatePicker
                      placeholderText="Select establish date"
                      className={`form-control ${
                        errors.foundationDate ? "is-invalid" : ""
                      }`}
                      selected={field.value}
                      onChange={field.onChange}
                      dateFormat="MM/dd/yyyy"
                    />
                  )}
                />
                <div className="invalid-feedback">
                  {errors.foundationDate?.message}
                </div>
              </Form.Group>
            </div>

            <div className="col-md-6 mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Client Country *</Form.Label>
                <Controller
                  name="clientCountry"
                  control={control}
                  rules={{ required: "Client Country is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={country}
                      placeholder="Choose..."
                      isInvalid={!!errors.clientCountry}
                    />
                  )}
                />
                {errors.clientCountry && (
                  <div className="text-danger">
                    {errors.clientCountry.message}
                  </div>
                )}
              </Form.Group>
            </div>
            <div className="col-md-6 mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">City</Form.Label>
                <Form.Control {...register("city")} placeholder="Enter city" />
              </Form.Group>
            </div>

            <div className="col-md-12 mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Pay Password</Form.Label>
                <Form.Control
                  {...register("payPassword")}
                  placeholder="Enter pay password"
                />
              </Form.Group>
            </div>

            {/* <div className="col-md-6 mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Number Of Employees</Form.Label>
                <Form.Control
                  type="number"
                  {...register("employeeCount")}
                  placeholder="Enter number of employees"
                />
              </Form.Group>
            </div> */}

            <div className="col-12 mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Company Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  {...register("companyAddress")}
                  placeholder="Enter company address"
                />
              </Form.Group>
            </div>

            <div className="col-12 mb-3">
              <Form.Group>
                <Form.Label className="fw-bold">Company Bio</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  {...register("companyBio")}
                  placeholder="Enter company bio"
                />
              </Form.Group>
            </div>
          </div>

          <div className="text-end mt-3">
            <Button type="submit" variant="primary">
              Submit
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditintroModal;
